
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 75,
    },
    {
        prop: "create_time",
        label: "开单时间",
        width: 75,
    },
    {
        prop: "order_message_give_text",
        label: "接车人",
        width: 75,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "settlementperson_text",
        label: "结算人",
        width: 75,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 75,
    },
    {
        prop: "price",
        label: "结算金额",
        width: 75,
    },
    {
        prop: "return_price",
        label: "待回款",
        width: 75,
    },
    {
        prop: "order_crd_code_text",
        label: "车牌号码",
        width: 75,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 75,
    },
    {
        prop: "order_message_give_text",
        label: "送修人",
        width: 75,
    },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 75,
    },
];

const partsColumn:Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 150,
    },
    {
        prop: "specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "mountings_type_p_name",
        label: "配件分类",
        width: 75,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 75,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 75,
    },
    {
        prop: "cost_price",
        label: "采购单价",
        width: 75,
    },
    {
        prop: "member",
        label: "数量",
        width: 75,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 75,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
    getLibraryInfo,
    workListExport,
    purchaseCopeExport,
    purchaseCopeInfo,
    permissionList,
    addBatchPayListPost, removeBatchPayListPost, purchasePayTotal,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
import {getFirstNowLastDay,getLastMonthDay} from "@/api/date";
export default defineComponent({
    name: "purchaseList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['采购应付']);
   
        const headClass = inject("headClass");
        //批量付款专区
        let batchPayList = reactive([]),
            batchDialog_show = ref(false),
            batchForm = reactive({
                purchase_number:"",
                number:"",
                price:"",
                pay_time:new Date(),
                pay_type:'',
                desc:''
            }),
            removeBatchList = reactive([]),
            payTotalClick = (()=>{
                batchDialog_show.value = true;
            }),
            batch_submit = (()=>{
                let date = Math.floor(batchForm.pay_time.getTime()/1000);
                let data = {
                    pay_time:date,
                    pay_type:batchForm.pay_type,
                    desc:batchForm.desc
                }
                loading.value = true;
                purchasePayTotal(data).then(()=>{
                    loading.value = false;
                    batchDialog_show.value = false;
                    getTableData()
                });
            }),
            removeClick = (()=>{
                if (removeBatchList.length==0){
                    alert('请选择数据');
                    return
                }
                let dataArr:any = [];
                removeBatchList.forEach((datum: any) => {
                    dataArr.push(datum.purchase_id);
                });
                let data = {
                    ids:dataArr.join(",")
                };
                removeBatchPayListPost(data).then((res:any)=>{
                    getTableData()
                });
        }),
            addBatchPayList = (()=>{
                if (batchPayList.length==0){
                    alert('请选择数据');
                    return
                }
                let dataArr:any = [];
                batchPayList.forEach((datum: any) => {
                    dataArr.push(datum.purchase_id);
                });
                let data = {
                    ids:dataArr.join(",")
                };
                addBatchPayListPost(data).then((res:any)=>{
                    getTableData()
                });
            }),
            handleDisable = ((row:any,index:number)=>{
                //return !tableData.value[row].is_payment;
                //console.log(index);
                return !row.is_payment;
            }),
            handleSelectionChange = ((selection:any)=>{
                batchPayList = [];
                removeBatchList = [];
                if (NavIndex.value==0){
                    batchPayList = selection;
                }else if(NavIndex.value==2){
                    removeBatchList = selection;
                }
            });
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            totalData = reactive({} as any),
            total = ref(0),
            loading = ref(true),
            type =  ref(''),
            roleList = ref({} as any),
            NavIndex = ref(-1),
            detailTable = ref([] as Array<any>),
            purchaseDetail = ref([] as any),
            detaildia_show = ref(false),
            isMountings = ref(false),
            route:any = useRoute(),
            Router:any = useRouter(),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search:''
            }),
            selectList = ref({
                supplier: [],
                staff: [],
                branch: [],
                zf: []
            }),
            form_rules:any = {
				pay_time: {required: true, message: '必填', trigger: 'blur'},
                price: {required: true, message: '必填', trigger: 'blur'},
                pay_type: {required: true, message: '必填', trigger: 'blur'},
			},
            remote_loading = ref(false),
            screenParameter = ref({
                type: null,
                search: '',
                start_time: null,
                end_time: null,
                page: currentPage.value,
                pagesize: pageSize.value,
                status: 0,
            } as any),
            dialog_model = ref(''),
            dialogTitle = ref("新增配件"),
            dialog_index = 0,
            dialog_load = ref(false),
            formRef = ref(null),
            form = ref({} as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
				cost_price: [{required: true,message: '必填',trigger: "change"}],
				mountings_type_pid: [{required: true,message: '必填',trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'purchaseList',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data;
                let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                //if (NavIndex.value == 0){
                    data = {...screenParameter.value,start_time:start_time,end_time:end_time,page: currentPage.value,
                        pagesize: pageSize.value};
               // }else {
                
                //}
                let url = '';
                switch (NavIndex.value){
                    case 0:
                        url = 'adminapi/Bookkeeping/purchaseCopeList';
                        break;
                        case 1:
                            url = 'adminapi/Bookkeeping/supplierSummary';
                            break;
                    case 2:
                        url = 'adminapi/Bookkeeping/purchaseBatchList';
                        break;
                }
                Request.axiosInstance({
                    url:  url,
                    data: data
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    totalData = res?.content;
                    if (NavIndex.value==2){
                        batchForm.purchase_number = res?.content?.total || 0;
                        batchForm.number = res?.content?.member_total || 0;
                        batchForm.price = res?.content?.total_stay_price || 0;
                    }
                })

            },
            getSummaries = (param:any): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "total_price",
                    "member"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
    
                        if (column.property == "total_price") {
                            sums[index] = `¥${purchaseDetail.value.cost_price_total}`;
                        }
                        if (column.property == "member") {
                            sums[index] = purchaseDetail.value.member_total;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            getDetailSummaries = (param:any): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "number",
                    "mining_price",
                    "stay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                
                        if (column.property == "number") {
                            sums[index] = totalData.member_total;
                        }
                        if (column.property == "mining_price") {
                            sums[index] = `¥${totalData.total_price}`;
                        }
                        if (column.property == "stay_price") {
                            sums[index] = `¥${totalData.total_stay_price}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            getsupplierSummaries = (param:any): Array<string> => {
                    const { columns, data } = param;
                    const sums: any = [];
                    const propArr = [
                        "number",
                        "price",
                        "purchases_number",
                        "stayPayment",
                    ];
                    columns.forEach((column: any, index: number) => {
                        if (index === 0) {
                            sums[index] = "合计";
                            return;
                        }
                        const values = data.map((item: any) =>
                            Number(item[column.property])
                        );
                        if (
                            propArr.findIndex((item: any) => {
                                return item == column.property;
                            }) > -1
                        ) {
                            // 增加合计项
                
                            if (column.property == "number") {
                                sums[index] = totalData.total_number;
                            }
                            if (column.property == "price") {
                                sums[index] = totalData.total_price;
                            }
                            if (column.property == "purchases_number") {
                                sums[index] = totalData.total_purchases_number;
                            }
                            if (column.property == "stayPayment") {
                                sums[index] = totalData.total_stayPayment;
                            }
                        } else {
                            sums[index] = "";
                        }
                    });
                    return sums;
                },
            // 点击单据编号触发
            bindPurchaseInfo = (purchase_id: number) => {
                purchaseCopeInfo({purchase_id}).then((res: any) => {
                if (res.status == 200) {
                  let info = res.content.list;
                    detailTable.value = info;
                    purchaseDetail.value = res.content;
                    detaildia_show.value = true;
                    if(res.content.parts.length > 0){
                      isMountings.value = true
                    }
                  
                }
              });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                purchaseCopeExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                // screenParameter[key] = e;
                // if(key == 'mountings_type_pid')
                // {
                //     screenParameter.value.mountings_type_id = null
                //     Request.axiosInstance({
                //         url: 'adminapi/MountingsType/list',
                //         data: {pid: screenParameter.value.mountings_type_pid}
                //     }).then((res: any) => {
                //          selectList.value.classificationb = res?.content?.list
                //     })
                //     return
                // }
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            screenChange = ( e: any, key: string): void => {
	
			   if (key == "time") {
                    screenParameter.value["start_time"] = e ?  (e[0] as Date).getTime() / 1000 : null
                    screenParameter.value["end_time"] = e? (e[1] as Date).getTime() / 1000 : null
               }
    
			    getTableData();
			},
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    let data: any = { ...form.value, id: 0 };
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({ type_pid: form.value.mountings_type_pid });
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            _submitForm = (): void => {
                
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/partsStockUpWarning',
                    data: form.value
                }).then((res: any) => {
                    if(res.status != 202) return
                    dialog_model.value = ''
                    getTableData()
                })
            },
            _form_submit = () => {
            //Math.floor这个还是要加上要不然有小数点
            let date = Math.floor(form.value.pay_time.getTime()/1000);
            let data = {...form.value,pay_time:date};
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid)  return

                    dialog_load.value = true
                    Request.axiosInstance({
                        url: dialog_model.value == 'edit2' ? 'adminapi/Bookkeeping/payForSupplier' : 'adminapi/Bookkeeping/implementPurchaseCope',
                        data: dialog_model.value == 'edit2' ?data:data
                    }).then((res) => {
                        dialog_load.value = false
                        if(res.status != 202) return
                        dialog_model.value = ''
                        getTableData()
                    })
                });
            },

            _option = (url: string , data: any) => {
				Router.push({
					path: url,
					query: data
				})
			},
            dateFormat =(time:any) =>{
            const t = new Date(time)
            // 日期格式
            const format = 'Y-m-d'
            let year = t.getFullYear()
            // 由于 getMonth 返回值会比正常月份小 1
            let month:number = t.getMonth() + 1
            let day = t.getDate()
            let hours = t.getHours()
            let minutes = t.getMinutes()
            let seconds = t.getSeconds()
            // month = month > 9 ? month : `0${month}`
            // day = day > 9 ? day : `0${day}`
            // hours = hours > 9 ? hours : `0${hours}`
            // minutes = minutes > 9 ? minutes : `0${minutes}`
            // seconds = seconds > 9 ? seconds : `0${seconds}`
            const hash = {
                'Y': year,
                'm': month,
                'd': day,
                'h': hours,
                'i': minutes,
                's': seconds
            } as any
            return format.replace(/\w/g, o => {
                return hash[o]
            })
        },
            _purchaseMarkin = (id: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseMarkin',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    getTableData()
                })
            },
            _upstatus = (id: number) => {

                if(!confirm("是否修改？")) return
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/upstate',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                })

                
            },
            payForBatch = (id: number, i: number) => {
                
                console.log(dateFormat(screenParameter.value.time[0]));
            form.value = {
                range_time:  dateFormat(screenParameter.value.time[0])+' 至 '+dateFormat(screenParameter.value.time[1]),
                supplier: tableData.value[i].supplier_name,
                purchase_number: tableData.value[i].purchases_number,
                number: tableData.value[i].number,
                price: tableData.value[i].stayPayment,
                pay_type: null,
                pay_time: new Date(),
                ids:tableData.value[i].purchaseArray
            }
            dialog_model.value = 'edit2'
        
        
        },
            _implementPurchaseCope = (id: number, i: number) => {
                form.value = {
                    stay_price:  tableData.value[i].stay_price,
                    discount_price:  tableData.value[i].discount_price,
                    already_price: tableData.value[i].already_price,
                    purchaes_number: tableData.value[i].purchaes_number,
                    purchase_id: tableData.value[i].purchase_id,
                    pay_time: new Date(),
                    pay_type: null,
                    admin_id: null,
                    desc: null,
                    price: tableData.value[i].stay_price<0?(tableData.value[i].stay_price*-1):tableData.value[i].stay_price,
                    mining_price:tableData.value[i].mining_price,
                    supplier:tableData.value[i].supplier,
                    purchase_type:tableData.value[i].purchase_type
                }
                dialog_model.value = 'edit1'
                console.log(form.value)

            },
            //工单确认结算的时候直接减免输入的逻辑判断
            reductionChange = (e: number): void => {
                (form.value as any)['discount_price'] = e;
                nextTick(() => {
                    // 减免要计算报价金额为最大减免（因为超过报价金额且存在预收款时，需要预收退款；存在余额时，则需要隐藏余额抵扣）
                    //let newValue = Math.min(e, (form.value as any)['order_offer_price']);
                    let newValue=0;
                    if (e>Number((form.value as any)['stay_price'])){
                        newValue = Number((form.value as any)['stay_price']);
                    }else{
                        newValue = e;
                    }
                    (form.value as any)['discount_price'] = newValue;
                    let subPrice = (form.value as any)['stay_price'] - (form.value as any)['discount_price'];

                    (form.value as any)['price'] = subPrice;
                    
                });
        
            },
            _incomeUpstar = (id: Number, type: Number) =>{

                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/incomeUpstar',
                    data: {income_id: id, type }
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                })

            }


        onMounted(() => {
    
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/supplier/totalList',
                    data: {status: 1}
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/constructors',
                    data: {}
                }),
                Request.axiosInstance({
                    url: 'adminapi/Basicset/totalList',
                    data: {basicset_type: 3}
                }),
                
            ]).then((res: any) => {
                selectList.value.supplier = res[0]?.content?.list
                selectList.value.staff = res[1]?.content?.staff
                selectList.value.branch = res[1]?.content?.branch
                selectList.value.zf = res[2]?.content?.list
            })
            NavIndex.value = 0

        });
        
        watch(NavIndex, (newval: any, oldval: any) => {
            tableData.value = []
            //currentPage.value = 0
            //pageSize.value = 10
            if(newval == 0)
            {
                screenParameter.value = {
                    store_id: null,
                    status: 0,
                    supplier_id: null,
                    employee_id: null,
                    search: null,
                    start_time: null,
                    end_time: null,
                    time:null
                }
            }
            else if(newval == 1)
            {
                screenParameter.value = {
                    start_time: null,
                    end_time: null,
                    time:[getLastMonthDay()[0],getLastMonthDay()[1]],
                }
            }
            else if(newval == 2)
            {
                screenParameter.value = {
                    batch_pay: 1
                }
            }

            getTableData()
        }),

        watch(dialog_model, (newval: any, oldval: any) => {
            if(newval == 'add'){
                form.value = {
                    time: null,
                    fixed_name: null,
                    fixed_price: null,
                    branch_id: null,
                    fixed_desc: null,
                    start_text: null,
                    end_text: null,
                    fixed_type: null,
                    expenditure_time: null,
                    admin_id: null,
                    pay_type: null,
                    expenditure_phone: null,
                    expenditure_payer: null,
                }
                dialog_load.value = false
            }
            else if(newval == 'edit')
            {
                // form.value = ({
                //     fixed_id: tableData.value[dialog_index].fixed_id,
                //     time: [new Date(tableData.value[dialog_index].start_text), new Date(tableData.value[dialog_index].end_text)],
                //     fixed_name: tableData.value[dialog_index].fixed_name,
                //     fixed_price: tableData.value[dialog_index].fixed_price,
                //     branch_id: tableData.value[dialog_index].branch_id,
                //     fixed_desc: tableData.value[dialog_index].fixed_desc,
                //     start_text: tableData.value[dialog_index].start_text,
                //     end_text: tableData.value[dialog_index].end_text,
                //     fixed_type: tableData.value[dialog_index].fixed_type,
                //     expenditure_time: null,
                //     admin_id: null,
                //     pay_type: null,
                //     expenditure_phone: null,
                //     expenditure_payer: null,
                // } as any)
                dialog_load.value = false
            }
            dialog_load.value = false

        })

    

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            _submitForm,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            dialog_model,
            screenChange,
            _incomeUpstar,
            dialog_index,
            _form_submit,
            form_rules,
            dialog_load,
            NavIndex,
            _upstatus,
            _implementPurchaseCope,
            payForBatch,
          detailTable,
          purchaseDetail,
          detaildia_show,
            batchDialog_show,
          isMountings,
          bindPurchaseInfo,
            exportChange,
            partsColumn,
            getSummaries,
            roleList,
            getDetailSummaries,
            totalData,
            getsupplierSummaries,
            reductionChange,
            removeClick,
            handleSelectionChange,
            handleDisable,
            addBatchPayList,
            batchPayList,
            payTotalClick,
            batchForm,
            batch_submit
        };
    },
});
